//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Button from '@components/atoms/button/Button';
import { InvisibleButtonStyles } from '@components/atoms/button/buttonStyles';
import { Mixins } from '@theme/mixins';

const buttonStyles = {
  ...InvisibleButtonStyles,
  active: {
    ...InvisibleButtonStyles.active,
    textDecoration: 'underline',
  },
  hover: {
    ...InvisibleButtonStyles.hover,
    textDecoration: 'underline',
  },
  isInlineWithText: true,
};

const LABEL_MIXIN = Mixins.Text.Caption;

interface ViewAllButtonProps {
  onClick?: () => void;
}

export const ViewAllButton = ({ onClick }: ViewAllButtonProps) => {
  return (
    <StyledButton
      buttonStyles={buttonStyles}
      onClick={onClick}
      textMixinOverride={LABEL_MIXIN}
    >
      View All
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  height: fit-content;
`;
